module.exports = __webpack_public_path__ + "static/media/star.bd320d65.svg";